export function appsSlider() {
    $(".apps-slider").each(function () {
        let $this = $(this);
        let attr = $this.attr('dir');
        let _rtl = typeof attr !== 'undefined' && attr === 'rtl';
        $this.slick({
            arrows: false,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 7000,
            pauseOnHover: false,
            cssEase: 'linear',
            rtl: _rtl,
            mobileFirst: true,
            responsive: [{
                breakpoint: 567,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4
                }
            }, {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 11
                }
            }]
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/appsSlider.js